import angular from 'angular';

import EmailVerificationConfirmComponent from './email-verification-confirm.cmpt';

export default angular
    .module('application.scene.identity.scene.email-verification-confirm', [])
    .component(EmailVerificationConfirmComponent.selector, EmailVerificationConfirmComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.email-verification.confirm', {
        url: '/re-send',
        template: '<db-a-email-verification-confirm class="block-component"></db-a-email-verification-confirm>'
    });
}




// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/email-verification/scene/email-verification-confirm/index.js